<template >
    <!--  BEGIN SIDEBAR  -->
<div class="sidebar-wrapper sidebar-theme px-2" :class="{ 'sidebar-collapsed': !isSidebarOpen }" style="background-color: #ebf2fc; margin-left: -12px; height: 100vh; display: flex; flex-direction: column;">
  
    <nav id="sidebar" style="flex: 1; display: flex; flex-direction: column; min-height: 0;">
        <div class="shadow-bottom"></div>
        <div class="menu-container" style="flex: 1; overflow-y: auto; overflow-x: hidden;">
            
            <ul class="list-unstyled menu-categories mt-2" id="accordionExample">
                <!-- Dynamic Menu Items from Database -->
                <li v-for="menu in menus" :key="menu.id" v-bind="corkSideBar">
                    <router-link 
                        v-if="!menu.permission || user_permissions.includes(menu.permission)"
                        :to="menu.path" 
                        class="dropdown-toggle bg-white"
                        style="border-radius: 15px;border-bottom:0.5px solid #a8a8a8"
                        :data-bs-target="`#menu-${menu.id}`"
                        :data-bs-toggle="menu.child_menus.length > 0 ? 'collapse' : null"
                        :aria-expanded="menu.child_menus.length > 0 ? 'false' : null"
                        @click="menu.child_menus.length === 0 && toggleMobileMenu()"
                    >
                        <div>
                            <span v-html="menu.svg"></span>
                            <span>{{ menu.name }}</span>
                        </div>
                        <svg
                            v-if="menu.child_menus.length > 0"
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            class="feather feather-chevron-down"
                        >
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </router-link>
                    
                    <!-- Submenu for child items -->
                    <ul 
                        v-if="menu.child_menus.length > 0" 
                        :id="`menu-${menu.id}`" 
                        class="collapse submenu list-unstyled"
                        data-bs-parent="#accordionExample"
                    >
                        <li v-for="child in menu.child_menus" :key="child.id" class="sub-menu">
                            <router-link 
                                v-if="!child.permission || user_permissions.includes(child.permission)"
                                :to="child.path"
                                :data-bs-target="`#submenu-${child.id}`"
                                :data-bs-toggle="child.sub_child_menus.length > 0 ? 'collapse' : null"
                                :aria-expanded="child.sub_child_menus.length > 0 ? 'false' : null"
                                @click="child.sub_child_menus.length === 0 && toggleMobileMenu(); child.expanded = !child.expanded"
                                style="color: black!important;border-radius: 15px;border-bottom:1px solid black;background-color:#d5deeb;margin: 35px;"
                                class="m-1 py-1"
                            >
                                {{ child.name }} 
                                <span v-if="child.sub_child_menus.length > 0">
                                    <svg v-if="!child.expanded" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-right" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                                        <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                                    </svg>
                                </span>
                            </router-link>
                            
                            <!-- Sub-submenu for grandchild items -->
                            <ul 
                                v-if="child.sub_child_menus.length > 0" 
                                :id="`submenu-${child.id}`" 
                                class="collapse list-unstyled sub-submenu px-2"
                            >
                                <li v-for="subchild in child.sub_child_menus" :key="subchild.id">
                                    <router-link 
                                        v-if="!subchild.permission || user_permissions.includes(subchild.permission)"
                                        :to="subchild.path"
                                        @click="toggleMobileMenu"
                                        style="color: black!important;border-radius: 15px;border-bottom:1px solid #696969;background-color:#cccfcd;"
                                        class="m-1 py-1"
                                    >
                                        {{ subchild.name }}
                                    </router-link>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>
    </nav>
</div>
    <!--  END SIDEBAR  -->
</template>

<script setup>
    import { onMounted, ref,inject,computed } from 'vue';
    import axios from 'axios';
    import { useStore } from 'vuex';
    const showError = inject('showError');
    const store = useStore();
    const user_role = ref('');
    const user = ref(null);
    const user_permissions = ref([]);
    import { useRouter, useRoute } from 'vue-router';
    const router = useRouter();
    const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL
});

const isSidebarOpen = ref(false)
    

    onMounted(() => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
  const storedUser = localStorage.getItem("user");
  if (!storedUser) {
    router.push('/');
  }
  if (storedUser) {
    user.value = JSON.parse(storedUser);
    user_role.value = user.value.role;
    user_permissions.value = user.value.permissions;
  }

    // Clear localStorage after 3 minutes (180000 ms)
    setTimeout(() => {
      localStorage.removeItem("user");
      router.push('/');
    }, 3600000); //clear after 30 minutes
    
    });

    const toggleMobileMenu = () => {
                    store.commit('toggleSideBar', !store.state.is_show_sidebar);
        // if (window.innerWidth < 991) {
        //     store.commit('toggleSideBar', !store.state.is_show_sidebar);
        // }
    };


const menus = ref([])
    const getMenus = async ()=>{
       try{
          const response = await axiosInstance.get('menus')
          menus.value = response.data
       }catch(error){
        console.log(error)
        showError(error.message)
       }
    }

const corkSideBar = ref('')
const getCorkSideBar = async()=>{
   const response = await axiosInstance.get(`header-styles`)
   corkSideBar.value = response.data
}

onMounted( async () => {
  await getCorkSideBar()
  getMenus()
  toggleMobileMenu()
})

</script>


<style scoped>
/* Simple native scroll solution */
.sidebar-wrapper {
    height: 100vh;
    overflow: hidden;
}

.menu-container {
    height: calc(100vh - 70px);
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
}

/* Custom scrollbar styling */
.menu-container::-webkit-scrollbar {
    width: 6px;
}

.menu-container::-webkit-scrollbar-track {
    background: #f1f1f1;
}

.menu-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 3px;
}

.menu-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Chevron rotation */
.chevron-rotated {
    transform: rotate(90deg);
}
</style>